var map = {
	"./symbol_0.png": "19d7",
	"./symbol_1.png": "83cb",
	"./symbol_10.png": "b182",
	"./symbol_11.png": "c3bc",
	"./symbol_12.png": "3739",
	"./symbol_2.png": "1c6e",
	"./symbol_3.png": "ba83",
	"./symbol_4.png": "53dc",
	"./symbol_5.png": "81d4",
	"./symbol_6.png": "6207",
	"./symbol_7.png": "e5a2",
	"./symbol_8.png": "355b",
	"./symbol_9.png": "d4bb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2907";